export class Order {

    id: string;
    orderId: string;
    orderStatus: string;
    customerName: string;
    orderDate: string;
    trackingSecret: string;
    emailAddress: string;
    orderItems: Array<OrderItem>;
    sequencingPrimers: Array<SequencingPrimer>;
    ecomLink: string;
    productionComment: string;
    internalComment: string;
    supportCategory: string;
    orderRef: string;
    productionOrderIds: Array<string>;
    samplePlateCount: number;
    sampleTubeCount: number;
    primerEnclosedCount: number;
    primerSynthesizedCount: number;
    processingOption: string;
    isRush: boolean;
    orderConfirmationDate: Date;
    materialReceivedDate: Date;
    isQCOverRule: boolean;
    isNxpUk: boolean;
    isDxP: boolean;
}

export class OrderItem {
    sampleId: string;
    sampleName: string;
    sampleType: string;
    templateSpecification: string;
    barcode: string;
    productType: string;
    stored: boolean;
    orderItemId: string;
    containerReceived: boolean;
    shortCode: string;
    unpurifiedSampleContainerBarcode: string;
    originalMaterialType: string;
    storagePlateBarcode: string;
    comment: string;
    printerTemplate: string;
    orderItemStatus: string;
    wellType: string;
    sitKey: string;
    isPresentInGatcLims: boolean;
    customerBarcode: string;
}
export class SequencingPrimer {
    primerId: string;
    primerType: string;
    primerName: string;
    primerBarcode: string;
    stored: boolean;
    orderItemId: string;
    notreceivablePrimer: boolean;
    materialReceived: boolean;
    shortCode: string;
    storagePlateBarcode: string;
    orderItemStatus: string;
    isPresentInGatcLims: boolean;
    printerTemplate: string;
}
export class Comment {
    id: string;
    comment: string;

    constructor(id: string, comment: string) {
        this.id = id;
        this.comment = comment;
    }
}
